import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';

export type FooterTokens = {
  backgroundColour: ThemeColorsKeys;
  includeInverseLogo: boolean;
  linkColour: ThemeColorsKeys;
  linkDividerColor: ThemeColorsKeys;
  linkHoverDecoration: string;
  seperateLinkBar: boolean;
  smallTextColor: ThemeColorsKeys;
  ruffleHeight?: string;
  ruffleBackgroundImage?: string;
  ruffleBackgroundSize?: string;
};

const tokens: FooterTokens = {
  backgroundColour: 'brandOne100',
  includeInverseLogo: true,
  linkColour: 'brandOne20',
  linkDividerColor: 'brandOne80',
  linkHoverDecoration: 'none',
  seperateLinkBar: false,
  smallTextColor: 'brandOne20',
} as const;

export default tokens;
